export const Logo = ({ className = "" }) => (
  <span className={`wyd-logo ${className}`} aria-label="WYD">
    WYD<span className="wyd-logo-dot" aria-hidden="true" />
  </span>
);
